module.exports = __webpack_public_path__ + "static/media/image_27.7ab9f13a.png";